export const Colors = {
    primary: "#060a78",
    primaryOpcaity: "#060a7820",
    succes: "#00b6bc",
    succesOpacity: "#00b6bc20",
    pending: "#ff642b",
    pendingOpcaity: "#ff642b30",
    iconColor: "#323232"
}